/* eslint-disable no-control-regex */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable no-await-in-loop */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable max-len */
import React, { useEffect, useMemo, useState } from 'react';
import { Dialog } from '@material-ui/core';
import { atom, useAtom } from 'jotai';
import { useHistory } from 'react-router';
import { useShipmentTracking } from 'src/lib/contexts/ShipmentTrackingContext';
import {
    eventMetricsMap,
    useCamera,
    useEventsReporter,
    useUserInfo,
} from 'src/hooks';
import { getProductDetailsQuery } from 'src/services/productServices';
import ROUTES from 'src/lib/routes';
// import 'react-barcode-scanner/polyfill';
import { Button, Heading } from '../UI';
import BarcodeInfoDrawer from './BarcodeInfoDrawer';
import LoadingOverlay from '../loading-overlay';
import { IconBack, IconInfoWhite } from '../Icons';
import ProductCard from '../product-card';
import ManualBarcodeEntry from './ManualBarcodeEntry';
import { ScannerError } from './types';
import ScanModal from '../shipping-services/components/ScanModal';
import styles from './styles.module.scss';
import { GuestModeErrorDialog, ScannerErrorDialog } from './ErrorComponents';

function verifyUpcCheckDigit(scannedCode: string): boolean {
    const scannedCheckDigit = Number(scannedCode[scannedCode.length - 1]);
    const code = scannedCode
        .slice(0, scannedCode.length - 1)
        .split('')
        .map(Number);
    const [evenSum, oddSum]: number[] = code.reduce(
        (accumulator: number[], currentValue: number, index) => {
            const newValue = [...accumulator];
            if ((index + 1) % 2 === 0) {
                newValue[0] += currentValue;
            } else {
                newValue[1] += currentValue;
            }
            return newValue;
        },
        [0, 0]
    );

    let calculatedCheckDigit = (oddSum * 3 + evenSum) % 10;
    calculatedCheckDigit =
        calculatedCheckDigit > 0
            ? 10 - calculatedCheckDigit
            : calculatedCheckDigit;
    return calculatedCheckDigit === scannedCheckDigit;
}

const infoDrawerAtom = atom(true);

interface BarcodeScannerProps {
    isScannerOpen: boolean;
    onClose: () => void;
    handleScan?: (value: string) => void;
}

function BarcodeScanner({
    onClose,
    handleScan,
}: Omit<BarcodeScannerProps, 'isScannerOpen'>) {
    const {
        goBackRoute,
        isScanCompleted,
        scanMessage,
        setIsScanCompleted,
        isLoading: isFetchingShippingData,
        setScanMessage,
        getShipmentTrackingDetails,
    } = useShipmentTracking();
    const history = useHistory();
    const [showManualBarcodeScreen, setShowManualBarcodeScreen] =
        useState(false);
    const [videoRef, setVideoRef] = useState<HTMLVideoElement | null>(null);
    const [showProductTile, setShowProductTile] = useState(false);
    const [scannedBarcode, setScannedBarcode] = useState<null | Pick<
        DetectedBarcode,
        'format' | 'rawValue'
    >>(null);
    const [productBarcode, setProductBarcode] = useState<string | null>(null);
    const [isInfoDrawerOpen, setIsInfoDrawerOpen] = useAtom(infoDrawerAtom);
    const [shouldDetectBarcode, setShouldDetectBarcode] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [scannerError, setScannerError] = useState<ScannerError>(null);
    const { analyticsCustomEvent } = useEventsReporter();
    const { userInfo } = useUserInfo();
    const { mediaStream, startCamera } = useCamera();
    const { data: productDetails, isFetching: isFetchingProductDetails } =
        getProductDetailsQuery({
            productBarcode: productBarcode as string,
            zipCode: userInfo?.currentLocationZipCode || '0',
            email: userInfo?.email || '',
            rewardsNumber: userInfo?.rewardsNumber || '',
            config: {
                enabled: !!productBarcode,
                staleTime: Infinity,
                onSettled: (_data, error) => {
                    console.log('273 onError triggered', error);
                    if (error) {
                        setProductBarcode(null);
                        setScannerError({
                            type: 'ProductNotFound',
                            body: 'We apologize, but we were unable to locate the product. Please consult an associate for further assistance.',
                        });
                    }
                },
            },
        });
    console.log('273 productDetails', productDetails);
    const startBarcodeDetection = () => setShouldDetectBarcode(true);
    const pauseBarcodeDetection = () => setShouldDetectBarcode(false);

    const extractBarcode = (barcodeData: string) => {
        // Use a regular expression to find the first special character (anything non-alphanumeric)
        const specialCharRemoved = barcodeData?.replace(/^[^\d]*(\d+)/, '$1');
        // This will match the first non-alphanumeric characte

        // If no special character is found, return the original string (or handle as needed)
        return specialCharRemoved;
    };

    const handleSearchError = (error: Error) => {
        analyticsCustomEvent(eventMetricsMap.scan, {
            click_text: 'scanned',
            scan_result: 'error',
        });
        if (
            showManualBarcodeScreen &&
            error.message === 'InvalidProductBarcode'
        ) {
            setScannerError({
                body: 'Barcode number is invalid.',
            });
        } else if (error.message === 'SignInRequired') {
            setScannerError({
                type: 'SignInRequired',
            });
        } else {
            setScannerError({
                title: 'Whoops!',
                body: 'We could not find this item. Please try scanning again.',
                ctaText: 'Try again',
                ctaAction: () => setScannerError(null),
            });
        }
    };

    const resetError = () => {
        setScannerError(null);
        setIsScanCompleted(false);
        setScanMessage({
            title: '',
            description1: '',
            point: '',
            description: '',
        });
    };

    const isBarcodeDetectorSupported = useMemo(
        () => 'BarcodeDetector' in window,
        []
    );

    const handleClose = () => {
        if (isInfoDrawerOpen) {
            setIsInfoDrawerOpen(false);
        } else if (showManualBarcodeScreen) {
            setShowManualBarcodeScreen(false);
            if (!isBarcodeDetectorSupported) {
                onClose();
            }
        } else {
            if (goBackRoute && goBackRoute === 'WALLETINFDRAWER') {
                history.push(ROUTES.rewardsWallet);
            }
            onClose();
        }
    };

    const barcodeDetector = useMemo(
        () =>
            isBarcodeDetectorSupported
                ? new BarcodeDetector({
                      formats: ['qr_code', 'code_128', 'upc_a'],
                  })
                : null,
        []
    );

    useEffect(() => {
        if (isBarcodeDetectorSupported) {
            startCamera();
        }
    }, [isBarcodeDetectorSupported]);

    useEffect(() => {
        if (
            showManualBarcodeScreen ||
            isFetchingProductDetails ||
            isFetchingShippingData ||
            (scannerError && scannerError.type !== 'ProductNotFound') ||
            !!scanMessage.title
        ) {
            pauseBarcodeDetection();
        } else {
            startBarcodeDetection();
        }
    }, [
        showManualBarcodeScreen,
        isFetchingProductDetails,
        scannerError,
        isFetchingShippingData,
        scanMessage,
    ]);

    useEffect(() => {
        if (mediaStream && videoRef) {
            videoRef.srcObject = mediaStream;
            videoRef.play().then(() => {
                startBarcodeDetection();
            });
        }
    }, [mediaStream, videoRef]);

    useEffect(() => {
        if (isBarcodeDetectorSupported && shouldDetectBarcode && videoRef) {
            const barcodeDectectionInterval = setInterval(async () => {
                if (barcodeDetector && videoRef) {
                    try {
                        const barcodes = await barcodeDetector.detect(videoRef); // Detect barcodes

                        if (barcodes.length > 0) {
                            console.log(
                                `273 BARCODE | format: ${barcodes[0].format} | value: ${barcodes[0].rawValue}`
                            ); // Show first detected barcode
                            setScannedBarcode(barcodes[0]);
                        }
                    } catch (err) {
                        console.error('Error detecting barcode:', err);
                    }
                }
            }, 750);
            return () => {
                clearInterval(barcodeDectectionInterval);
            };
        }
        return undefined;
    }, [shouldDetectBarcode, videoRef, isBarcodeDetectorSupported]);

    useEffect(() => {
        if (!isBarcodeDetectorSupported) {
            setShowManualBarcodeScreen(true);
            setIsInfoDrawerOpen(false);
        }
    }, [isBarcodeDetectorSupported]);

    useEffect(() => {
        if (scannedBarcode && !isScanCompleted) {
            let scannedAndVerifiedCode = scannedBarcode.rawValue;
            const codeType = scannedBarcode.format;
            resetError();

            try {
                setShowLoader(true);
                switch (codeType) {
                    case 'qr_code': {
                        // Handle QR code
                        const decodedURL = new URL(scannedAndVerifiedCode);
                        if (
                            decodedURL.origin ===
                            process.env.REACT_APP_COUPON_DEEPLINK_DOMAIN
                        ) {
                            pauseBarcodeDetection();
                            window.location.replace(scannedAndVerifiedCode);
                            break;
                        }
                        throw new Error('Invalid URL scanned');
                    }
                    case 'upc_a':
                        if (verifyUpcCheckDigit(scannedAndVerifiedCode)) {
                            scannedAndVerifiedCode = `00${scannedAndVerifiedCode}`;
                            setProductBarcode(scannedAndVerifiedCode);
                            setShowProductTile(true);
                            setIsInfoDrawerOpen(false);
                            break;
                        }
                        throw new Error('InvalidProductBarcode');
                    case 'code_128':
                        scannedAndVerifiedCode = extractBarcode(
                            scannedAndVerifiedCode
                        );
                        if (userInfo) {
                            getShipmentTrackingDetails(scannedAndVerifiedCode);
                            break;
                        }
                        throw new Error('SignInRequired');
                    default:
                        throw new Error('Code type not supported');
                }
            } catch (error) {
                handleSearchError(error as Error);
            } finally {
                setShowLoader(false);
                setScannedBarcode(null);
            }
        }
    }, [scannedBarcode?.rawValue, scannedBarcode?.format]);

    useEffect(() => {
        console.log('273 error reset');
        resetError();
        // Reset errors on unmount as well
        return () => {
            resetError();
        };
    }, [showManualBarcodeScreen]);

    console.log('273 scannerError', scannerError);
    console.log('273 showManualBarcodeScreen', showManualBarcodeScreen);

    return (
        <>
            <Dialog fullScreen open>
                <div className={styles.container}>
                    <div className={styles.headerContainer}>
                        <Button
                            variant="icon"
                            onClick={handleClose}
                            contentClassName={styles.buttonContent}
                        >
                            <IconBack fillColor="fillWhite" />
                        </Button>
                        <Heading
                            color="textWhite"
                            type="h6"
                            className={styles.header}
                            size={20}
                            weight="bold"
                        >
                            Scanner
                        </Heading>
                        <Button
                            variant="icon"
                            onClick={() =>
                                setIsInfoDrawerOpen(!isInfoDrawerOpen)
                            }
                            contentClassName={styles.buttonContent}
                        >
                            <IconInfoWhite width={20} height={20} />
                        </Button>
                    </div>
                    <div className={styles.scannerContainer}>
                        {showManualBarcodeScreen ||
                        !isBarcodeDetectorSupported ? (
                            <ManualBarcodeEntry
                                onClose={() => {
                                    console.log('273 onclose line 342');
                                    setShowManualBarcodeScreen(false);
                                    if (!isBarcodeDetectorSupported) {
                                        handleClose();
                                    }
                                }}
                                onSearch={(barcode) => {
                                    resetError();
                                    setScannedBarcode(barcode);
                                }}
                                scannerError={scannerError?.body}
                                setScannerError={setScannerError}
                                setIsInfoDrawerOpen={setIsInfoDrawerOpen}
                                isInfoDrawerOpen={isInfoDrawerOpen}
                            />
                        ) : (
                            <>
                                <video
                                    className={styles.videoStream}
                                    ref={setVideoRef}
                                    autoPlay
                                    disablePictureInPicture
                                />

                                <div className={styles.scannerWindow}>
                                    <span className={styles.topLeft} />
                                    <span className={styles.topRight} />
                                    <span className={styles.bottomLeft} />
                                    <span className={styles.bottomRight} />
                                    <Button
                                        className={styles.manualEntryButton}
                                        onClick={() => {
                                            setShowManualBarcodeScreen(true);
                                            setIsInfoDrawerOpen(false);
                                        }}
                                        variant="text"
                                    >
                                        Enter product barcode manually
                                    </Button>
                                </div>
                                <ScannerErrorDialog
                                    scannerError={scannerError}
                                    onClose={() => {
                                        setScannerError(null);
                                    }}
                                />
                                <GuestModeErrorDialog
                                    open={
                                        scannerError?.type === 'SignInRequired'
                                    }
                                    onClose={resetError}
                                />
                            </>
                        )}
                        {showProductTile && !isFetchingProductDetails && (
                            <ProductCard
                                onClose={(
                                    event: React.MouseEvent<
                                        HTMLButtonElement,
                                        MouseEvent
                                    >
                                ) => {
                                    event.stopPropagation();
                                    setScannerError(null);
                                    setShowProductTile(false);
                                }}
                                productDetails={productDetails}
                                productCode={productBarcode}
                                scannerError={
                                    scannerError?.type === 'ProductNotFound' &&
                                    !showManualBarcodeScreen
                                }
                            />
                        )}
                    </div>
                </div>

                <LoadingOverlay
                    variant="wordmark"
                    theme="light"
                    open={showLoader || isFetchingProductDetails}
                />
                <BarcodeInfoDrawer
                    open={isInfoDrawerOpen}
                    onClose={() => {
                        setIsInfoDrawerOpen(false);
                    }}
                    onOpen={() => {
                        setIsInfoDrawerOpen(true);
                    }}
                />
            </Dialog>
            {((isScanCompleted &&
                !showManualBarcodeScreen &&
                scanMessage?.description) ||
                (isScanCompleted &&
                    showManualBarcodeScreen &&
                    scanMessage?.title?.includes?.('Scan successful'))) && (
                <ScanModal handleScan={handleScan} />
            )}
        </>
    );
}

function BarcodeScannerWrapper(props: BarcodeScannerProps) {
    console.log('273 props.isScannerOpen', props.isScannerOpen);
    if (props.isScannerOpen) {
        return <BarcodeScanner {...props} />;
    }
    return null;
}

export default BarcodeScannerWrapper;
